module.exports = App.OrderPromoCardComponent = Em.Component.extend
  classNames: ['order-promo-card']
  classNameBindings: ['isActive::disabled', 'delayed::delayed']
  isLoading: false

  promo: null
  order: null

  isActive: (->
    @get('promo.is_active') and not @get('promo.is_delayed')
  ).property('promo.is_active', 'promo.is_delayed')

  isDelayed: (->
    @get('promo.is_active') and @get('promo.is_delayed')
  ).property('promo.is_active', 'promo.is_delayed')

  delayed: (->
    not @get('promo.is_delayed') and @get('promo.is_active')
  ).property('promo.is_active', 'promo.is_delayed')

  showToggle: (->
    @get('order.status') is 'draft'
  ).property('order.status')

  onDelayedChange: (->
    @set('isLoading', true)
    order = @get('order')
    order.nonRESTAction('PUT', "delay/#{@get('promo.id')}", {
      delay: String not @get('delayed')
    }).then =>
      order.reload()
      order.get('buddies').reload()
      @set('isLoading', false)
  ).observes('delayed')

  checkBonusChoise: Ember.observer (
    'promo.bonuses.@each.selected_dish_id'
    ->
      bonuses = @get('promo.bonuses')
      if Ember.isArray(bonuses)
        bonuses.forEach (bonus) ->
          if Ember.isArray(bonus.choices)
            bonus.choices.forEach (item) ->
              item.selected = item.dish_id is bonus.selected_dish_id
  ).on('init')



  actions:
    selectBonusDish: (bonus, dish) ->
      @set('isLoading', true)
      @get('order').selectBonusDish(bonus,dish)
      .then =>
        @sendAction('onSelectDish')
        @set('isLoading', false)